module.exports = __webpack_public_path__ + "img/11.cfa8f844.jpg";